export class AdlocateClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
    }
    // Adlocateの流入用タグ
    loadViewScript() {
        const script = document.createElement('script');
        script.innerHTML = `
      var _CIDN = "cid";
      var _PMTN = "p";
      var _LPTU = "./";
      var _param = location.search.substring(1).split("&");
      var _ulp = "", _ulcid = "";
      for(var i = 0; _param[i]; i++){ var kv = _param[i].split("="); if(kv[0] == _PMTN && kv[1].length > 1){ _ulp = kv[1]; } if(kv[0] == _CIDN && kv[1].length > 1){ _ulcid = kv[1]; }}
      if(_ulp && _ulcid){ _xhr = new XMLHttpRequest(); _xhr.open("GET", _LPTU + "lptag.php?p=" + _ulp + "&cid=" + _ulcid); _xhr.send(); localStorage.setItem("CL_" + _ulp, _ulcid); }
    `;
        document.getElementsByTagName('head')[0].appendChild(script);
    }
    // Adlocateのコンバージョン用タグ
    loadConversionScript(userID, email) {
        const script = document.createElement('script');
        script.innerHTML = `
      var _CIDN = "cid";
      var _PMTV = "610357fc2c5fd";
      var _ARGSV = "${userID}";
      var _TKP1V = "";
      var _TKP2V = "${email}";
      var _TKP3V = "";
      var _TKP4V = "";
      var _TKP5V = "";
      var _TKP6V = "";
      var _TKP7V = "";
      var _TKP8V = "";
      var _TKP9V = "";
      var _TKP10V = "";
      var _TRKU = "https://adlocate.jp/track.php?p=" + _PMTV + "&t=610357fc&args=" + _ARGSV + "&tkp1=" + _TKP1V + "&tkp2=" + _TKP2V + "&tkp3=" + _TKP3V + "&tkp4=" + _TKP4V + "&tkp5=" + _TKP5V + "&tkp6=" + _TKP6V + "&tkp7=" + _TKP7V + "&tkp8=" + _TKP8V + "&tkp9=" + _TKP9V + "&tkp10=" + _TKP10V;
      var _cks = document.cookie.split("; ");
      var _cidv = "";
      for(var i = 0; i < _cks.length; i++){ var _ckd = _cks[i].split( "=" ); if(_ckd[0] == "CL_" + _PMTV && _ckd[1].length > 1){ _cidv = _ckd[1]; break; }}
      if(!_cidv && localStorage.getItem("CL_" + _PMTV)){ _cidv = localStorage.getItem("CL_" + _PMTV); }
      if(_cidv){ _TRKU += "&" + _CIDN + "=" + _cidv; }
      img = document.body.appendChild(document.createElement("img"));
      img.src = _TRKU;
    `;
        document.getElementsByTagName('body')[0].appendChild(script);
    }
}
